/* eslint-disable */
import variables from '!!sass-variable-loader!../scss/_variables.scss';
export default variables;
